import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { Annotation } from '@rossum/api-client/annotations';
import { DetailDrawer } from '@rossum/ui';
import { Stack } from '@rossum/ui/material';
import { UnpaidFeatureOverlay } from '../../pricing/components/UnpaidFeatureOverlay';
import { approvalWorkflowsFeatureSelector } from '../../pricing/selectors';
import { RequestDetailBodyActivity } from '../../workflows';

type WorkflowActivityDrawerProps = {
  annotation: Annotation;
  onClose: () => void;
};

export const WorkflowActivityDrawer = ({
  annotation,
  onClose,
}: WorkflowActivityDrawerProps) => {
  const intl = useIntl();

  const isWorkflowsPurchased = useSelector(approvalWorkflowsFeatureSelector);

  return (
    <DetailDrawer
      open
      onClose={onClose}
      title={intl.formatMessage({
        id: 'components.workflowActivityDrawer.title',
      })}
    >
      {isWorkflowsPurchased ? (
        <Stack p={2}>
          <RequestDetailBodyActivity annotation={annotation} />
        </Stack>
      ) : (
        <UnpaidFeatureOverlay
          title={intl.formatMessage({
            id: 'features.pricing.unpaidFeatureOverlay.title.approvalWorkflows',
          })}
          dataCy="unpaid-overlay-workflow-activity-drawer"
        />
      )}
    </DetailDrawer>
  );
};
